module.exports = __webpack_public_path__ + "img/footer-logo-tw.8a287add.png";